module.exports = "<div (click)=\"goBack()\" class=\"exit-view-wrapper\"><nv-icon name=\"{{ icon }}\"></nv-icon></div>\n"